/* eslint-disable react-refresh/only-export-components */
import { Twitch, X, YouTube } from '@streamelements/frontend-icons';
import { styled } from '@streamelements/frontend-ui';
import { ComponentProps, forwardRef, PropsWithChildren } from 'react';
import { AllowedProvider } from '../constants/common';
import { StreamIcon } from './Icons/StreamIcon';
import { IconPrimitive } from './Icons';

const ProviderIcon = styled(IconPrimitive, {
  '&&': {
    br: '0.25rem',
  },

  defaultVariants: {
    size: 'md',
  },
});

const TwitchIcon = forwardRef<SVGSVGElement, ComponentProps<typeof IconPrimitive>>(function TwitchIcon(props, ref) {
  return (
    <ProviderIcon
      {...props}
      viewBox="0 0 24 24"
      as={Twitch}
      css={{
        bgc: '$twitchPurple',
        color: '$textAlwaysLightMain',
        path: { transform: 'scale(0.9)', transformOrigin: 'center' },
        ...props.css,
      }}
      ref={ref}
    />
  );
});

const YouTubeIcon = forwardRef<SVGSVGElement, ComponentProps<typeof IconPrimitive>>(function YouTubeIcon(props, ref) {
  return (
    <ProviderIcon
      {...props}
      viewBox="0 0 24 24"
      as={YouTube}
      css={{
        bgc: '$youtubeRed',
        color: 'white',
        path: { transform: 'scale(0.9)', transformOrigin: 'center' },
        ...props.css,
      }}
      ref={ref}
    />
  );
});

const TrovoIcon = forwardRef<SVGSVGElement, ComponentProps<typeof IconPrimitive>>(function TrovoIcon(props, ref) {
  return (
    <ProviderIcon {...props} ref={ref} viewBox="0 0 24 24" css={{ bgc: '$trovoGreen', color: 'white', ...props.css }}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.93 4.114A.387.387 0 0014.657 4h-4.68a.583.583 0 00-.555.43L8.903 6.63a.384.384 0 01-.372.288H5.538a.585.585 0 00-.564.456l-.965 4.344a.394.394 0 00.38.478H7.46a.292.292 0 01.282.223c.01.042.003.128.003.128s-.152.917-.185 1.382c-.094 1.352.255 2.832 1.31 3.99 1.794 1.97 5.11 2.084 7.07.991 1.576-.877 2.27-2.498 1.934-3.86-.27-1.09-1.074-1.814-2.207-1.805-1.11.008-1.726.721-1.808 1.514-.063.585.159 1.05.477 1.243.59.352.999-.248.77-.47-.145-.144-.216-.262-.18-.48.033-.22.194-.435.581-.435.388 0 .715.278.784.858a1.463 1.463 0 01-1.145 1.589c-.989.212-1.987-.322-2.343-1.184-.355-.86-.259-2.205.589-3.026.671-.65 1.538-.89 2.277-.89l2.471.11a.39.39 0 00.39-.295l1.058-4.364a.368.368 0 00.012-.094c0-.217-.148-.392-.36-.392h-4.52a.192.192 0 01-.18-.127.2.2 0 01-.008-.112l.503-2.208a.394.394 0 00-.105-.367z"
      />
    </ProviderIcon>
  );
});

const XIcon = forwardRef<SVGSVGElement, ComponentProps<typeof IconPrimitive>>(function XIcon(props, ref) {
  return (
    <ProviderIcon
      {...props}
      as={X}
      viewBox="0 0 24 24"
      css={{ bgc: '$textPrimaryMain', color: '$textPrimaryMainInverted', ...props.css }}
      ref={ref}
    />
  );
});

const TikTokIcon = forwardRef<SVGSVGElement, ComponentProps<typeof IconPrimitive>>(function TikTokIcon(props, ref) {
  return (
    <ProviderIcon
      {...props}
      ref={ref}
      viewBox="0 0 24 24"
      css={{ bgc: '$textPrimaryMain', color: '$textPrimaryMainInverted', ...props.css }}
    >
      <path d="M19.028 8a4.034 4.034 0 0 1-4.04-4H12.38v7.128l-.004 3.904a2.36 2.36 0 0 1-2.498 2.356 2.35 2.35 0 0 1-1.08-.331 2.36 2.36 0 0 1-1.154-1.99 2.363 2.363 0 0 1 3.11-2.276v-2.648a5 5 0 0 0-.752-.056c-1.443 0-2.793.6-3.758 1.681A4.9 4.9 0 0 0 5.01 14.72a4.89 4.89 0 0 0 1.455 3.807q.225.222.471.412a5 5 0 0 0 3.066 1.036q.383 0 .753-.055a5 5 0 0 0 2.785-1.393 4.88 4.88 0 0 0 1.465-3.475l-.014-5.83q.675.52 1.465.854c.819.346 1.686.52 2.58.52V8z" />
    </ProviderIcon>
  );
});

const CustomProvider = forwardRef<SVGSVGElement, PropsWithChildren<ComponentProps<typeof IconPrimitive>>>(
  function CustomProvider(props, ref) {
    // <ProviderIcon ref={ref} viewBox="0 0 24 24" css={props.css} {...props}>
    //   <path d="M18 13h-5v5c0 .55-.45 1-1 1s-1-.45-1-1v-5H6c-.55 0-1-.45-1-1s.45-1 1-1h5V6c0-.55.45-1 1-1s1 .45 1 1v5h5c.55 0 1 .45 1 1s-.45 1-1 1" />
    // </IconPrim>
    return <StreamIcon ref={ref} {...props} />;
  }
);

const KickIcon = forwardRef<SVGSVGElement, ComponentProps<typeof IconPrimitive>>(function KickIcon(props, ref) {
  return (
    <ProviderIcon
      ref={ref}
      viewBox="0 0 24 24"
      {...props}
      css={{ bgc: '$textAlwaysDarkMain', color: '$kickGreen', ...props.css }}
    >
      <path d="M10.502 5H6v14h4.502v-3.107H12v1.553h1.498V19H18v-4.67h-1.498v-1.553h-1.498v-1.554h1.498V9.67H18V5h-4.502v1.554H12v1.553h-1.498z" />
    </ProviderIcon>
  );
});

export const providerIcons: Record<AllowedProvider, React.ElementType> = {
  twitch: TwitchIcon,
  youtube: YouTubeIcon,
  trovo: TrovoIcon,
  x: XIcon,
  custom: CustomProvider,
  tiktok: TikTokIcon,
  kick: KickIcon,
};
